/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import ApplicationListView from './views/ApplicationListView.vue'
import ApplicationView from './views/ApplicationView.vue'
import auth from './app/auth';
import LogoutSuccess from '@/components/LogoutSuccess';
import UserInfoStore from './app/user-info-store';
import UserInfoApi from './app/user-info-api';
import ErrorComponent from '@/components/Error';
import Store from '@/store/store'

Vue.use(Router)

function requireAuth(to, from, next) {
  
  if (!auth.auth.isUserSignedIn()) {
      UserInfoStore.setLoggedIn(false);
      next({
      path: '/login',
      query: { redirect: to.fullPath }
      });
  } else {
    UserInfoStore.setUserGroup(UserInfoApi.getGroupInfo());
    UserInfoApi.getUserInfo().then(response => {
      UserInfoStore.setLoggedIn(true);
      UserInfoStore.setCognitoInfo(response.data); 
      Store.state.userName = response.data.username;
      Store.state.userID = response.data.email;
      Store.state.userGroup =  UserInfoApi.getGroupInfo();  
      next();
    });
      
  }
}

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/application/:id',
      name: 'ApplicationView',
      component: ApplicationView,
      beforeEnter: requireAuth
    },
    {
      path: '/',
      name: 'ApplicationListView',
      component: ApplicationListView,
      beforeEnter: requireAuth
    },
    {
      path: '/login', beforeEnter(to, from, next){
        auth.auth.getSession();
      }
    },
    {
      path: '/login/oauth2/code/cognito', beforeEnter(to, from, next){
        var currUrl = window.location.href;
        
        //console.log(currUrl);
        auth.auth.parseCognitoWebResponse(currUrl);
        //next();
      }
    },
    {
      path: '/logout', component: LogoutSuccess,  beforeEnter(to, from, next){
        auth.logout();
        next();
      }

    },
    {
      path: '/error', component: ErrorComponent
    }
  ]
})
